import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createElementVNode as _createElementVNode, unref as _unref, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '@/assets/image/WechatIMG4190.jpg'
import _imports_1 from '@/assets/image/WechatIMG4191.jpg'
import _imports_2 from '@/assets/image/invite_times.jpg'
import _imports_3 from '@/assets/image/invite_commission.jpg'


const _withScopeId = n => (_pushScopeId("data-v-723bde6d"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "invite" }
const _hoisted_2 = {
  key: 0,
  class: "invite-background",
  src: _imports_2,
  alt: ""
}
const _hoisted_3 = {
  key: 1,
  class: "invite-background",
  src: _imports_3,
  alt: ""
}
const _hoisted_4 = ["src"]

import {onMounted, onUpdated, reactive} from "vue";
import {Random} from "mockjs";
import {mockArr, req} from "@/lib/util";
import {
  ITemplate,
  tagsFestival,
  tagsTarget,
  tagsModel
} from "@/app/templates/index";
import emit from "@/lib/emit";
import {account} from "@/app/login";
import {CloseOutlined} from "@ant-design/icons-vue";
import PopupBase from "@/components/PopupBase.vue";
import BlockDrafts from "@/app/templates/BlockDrafts.vue";
import BlockTemplates from "@/app/templates/BlockTemplates.vue";
import BlockFootMark from "@/app/templates/BlockFootMark.vue";
import BlockActivityInProgress from "@/app/templates/BlockActivityInProgress.vue";


export default /*#__PURE__*/_defineComponent({
  __name: 'TemplatesPanelView',
  setup(__props) {

const info = reactive({templates: [] as ITemplate[], loading: false, invite: {show: false, isTimes: false}})

onMounted(() => {
  mockArr('templates', 'get', 200, 300, {
    'template_id|18': /\w/,
    title: '@ctitle(6,28)',
    poster: "@pick(['https://b.s.mywsy.cn/media/image/template/80041ff1ba8345894d1840382eb5c883.gif', 'https://b.s.mywsy.cn/media/image/template/4241ae73b4f20f325be716512bf9d530.gif', 'https://b.s.mywsy.cn/media/image/template/c29f10ad83b333e0c0b923f77059bf8b.png'])",
    tags: () => [Random.pick(Object.keys(tagsFestival)), Random.pick(Object.keys(tagsTarget)), ...Random.pick(Object.keys(tagsModel), 1, 2)],
    text_tags: [],
    create_at: '@datetime',
    'use_count|1-1000': 1
  })
  info.loading = true
  req({
    url: 'templates', success: rs => {
      info.templates = rs
    }, complete: () => {
      info.loading = false
      emit.emit('templates.list.loaded')
    }
  })
})

onUpdated(() => {
  info.templates = JSON.parse(JSON.stringify(info.templates))
})

return (_ctx: any,_cache: any) => {
  const _component_a_col = _resolveComponent("a-col")!
  const _component_a_carousel = _resolveComponent("a-carousel")!
  const _component_a_row = _resolveComponent("a-row")!

  return (_openBlock(), _createBlock(_component_a_row, { gutter: 10 }, {
    default: _withCtx(() => [
      _createVNode(_component_a_col, { span: 18 }, {
        default: _withCtx(() => [
          _createVNode(BlockTemplates, {
            spinning: info.loading,
            templates: info.templates
          }, null, 8, ["spinning", "templates"])
        ]),
        _: 1
      }),
      _createVNode(_component_a_col, { span: 6 }, {
        default: _withCtx(() => [
          _createVNode(_component_a_carousel, {
            class: "ad",
            autoplay: "",
            "dots-class": "ad-dots"
          }, {
            default: _withCtx(() => [
              _createElementVNode("img", {
                src: _imports_0,
                alt: "ad1",
                onClick: _cache[0] || (_cache[0] = ($event: any) => {info.invite.isTimes=true;info.invite.show=true;})
              }),
              _createElementVNode("img", {
                src: _imports_1,
                alt: "ad2",
                onClick: _cache[1] || (_cache[1] = ($event: any) => {info.invite.isTimes=false;info.invite.show=true;})
              })
            ]),
            _: 1
          }),
          _createVNode(BlockActivityInProgress),
          _createVNode(BlockDrafts),
          _createVNode(BlockFootMark)
        ]),
        _: 1
      }),
      _createVNode(PopupBase, {
        open: info.invite.show,
        "onUpdate:open": _cache[3] || (_cache[3] = ($event: any) => ((info.invite.show) = $event))
      }, {
        default: _withCtx(() => [
          _createVNode(_unref(CloseOutlined), {
            style: {"position":"absolute","top":"14px","right":"14px","color":"white","z-index":"1"},
            onClick: _cache[2] || (_cache[2] = ($event: any) => (info.invite.show=false))
          }),
          _createElementVNode("div", _hoisted_1, [
            (info.invite.isTimes)
              ? (_openBlock(), _createElementBlock("img", _hoisted_2))
              : (_openBlock(), _createElementBlock("img", _hoisted_3)),
            _createElementVNode("img", {
              class: "invite-qr",
              alt: "",
              src: `https://api.activity.djhdb.cn/pc/open/qr/invite?bid=${_unref(account).user?.browser_id}&is_times=${info.invite.isTimes ? 't' : 'f'}`
            }, null, 8, _hoisted_4)
          ])
        ]),
        _: 1
      }, 8, ["open"])
    ]),
    _: 1
  }))
}
}

})